import api from '../api/client';
// // components/SiloManagement.jsx
// import React, { useState, useEffect } from 'react';
// import { Card, Table, Button, Modal, Form, Input, Select, InputNumber, Space, Tag, message, Tooltip } from 'antd';
// import { PlusOutlined, EditOutlined, ArrowLeftOutlined } from '@ant-design/icons';
// import axios from 'axios';
// import config from '../config';
// import { Link } from 'react-router-dom/cjs/react-router-dom.min';

// const { Option } = Select;

// const SiloManagement = () => {
//     const [silos, setSilos] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [modalVisible, setModalVisible] = useState(false);
//     const [editingSilo, setEditingSilo] = useState(null);
//     const [form] = Form.useForm();
//     const [assetTypes, setAssetTypes] = useState([]);
//     const [farms, setFarms] = useState([]);

//     const environment = window.location.hostname === 'localhost' ? 'development' : 'production';
//     const apiUrl = config[environment].apiUrl;

//     useEffect(() => {
//         fetchSilos();
//         fetchAssetTypes();
//         fetchFarms();
//     }, []);

//     const fetchSilos = async () => {
//         setLoading(true);
//         try {
//             const response = await api.get(`/silos`);
//             setSilos(response.data);
//         } catch (error) {
//             console.error('Error fetching silos:', error);
//             message.error('Failed to load silos');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const fetchAssetTypes = async () => {
//         try {
//             const response = await api.get(`/asset-types-config`);
//             setAssetTypes(response.data);
//         } catch (error) {
//             console.error('Error fetching asset types:', error);
//         }
//     };

//     const fetchFarms = async () => {
//         try {
//             const response = await api.get(`/farm`);
//             setFarms(response.data);
//         } catch (error) {
//             console.error('Error fetching farms:', error);
//         }
//     };

//     const handleCreate = async (values) => {
//         try {
//             const response = await api.post(`/silos`, {
//                 ...values,
//                 user_id: 1,
//                 user_name: 'Admin'
//             });

//             if (response.data.success) {
//                 message.success('Silo created successfully');
//                 setModalVisible(false);
//                 form.resetFields();
//                 fetchSilos();
//             }
//         } catch (error) {
//             console.error('Error creating silo:', error);
//             message.error('Failed to create silo');
//         }
//     };

//     const handleUpdate = async (values) => {
//         try {
//             await api.put(`/silos/${editingSilo.id}`, values);
//             message.success('Silo updated successfully');
//             setEditingSilo(null);
//             setModalVisible(false);
//             form.resetFields();
//             fetchSilos();
//         } catch (error) {
//             console.error('Error updating silo:', error);
//             message.error('Failed to update silo');
//         }
//     };

//     const columns = [
//         { title: 'Silo #', dataIndex: 'silo_number', key: 'silo_number', width: 100 },
//         { title: 'Name', dataIndex: 'name', key: 'name', width: 150 },
//         {
//             title: 'Type',
//             dataIndex: 'type_slug',
//             key: 'type_slug',
//             render: (slug) => {
//                 const type = assetTypes.find((t) => t.slug === slug);
//                 return <Tag color={type?.color}>{type?.name || slug}</Tag>;
//             },
//             width: 100
//         },
//         { title: 'Farm', dataIndex: 'farm_name', key: 'farm_name', width: 120 },
//         { title: 'Location', dataIndex: 'location', key: 'location', width: 150 },
//         {
//             title: 'Capacity',
//             dataIndex: 'capacity',
//             key: 'capacity',
//             render: (cap) => (cap ? `${cap} units` : 'Unlimited'),
//             width: 100
//         },
//         {
//             title: 'Occupancy',
//             key: 'occupancy',
//             render: (_, record) => {
//                 if (!record.capacity) return '-';
//                 const percent = (record.current_occupancy / record.capacity) * 100;
//                 return `${record.current_occupancy} / ${record.capacity} (${percent.toFixed(1)}%)`;
//             },
//             width: 120
//         },
//         {
//             title: 'Status',
//             dataIndex: 'status',
//             key: 'status',
//             render: (status) => {
//                 const colors = { active: 'green', maintenance: 'orange', full: 'red', empty: 'default' };
//                 return <Tag color={colors[status]}>{status}</Tag>;
//             },
//             width: 100
//         },
//         {
//             title: 'Actions',
//             key: 'actions',
//             width: 100,
//             render: (_, record) => (
//                 <Space>
//                     <Tooltip title="Edit">
//                         <Button
//                             icon={<EditOutlined />}
//                             size="small"
//                             onClick={() => {
//                                 setEditingSilo(record);
//                                 form.setFieldsValue(record);
//                                 setModalVisible(true);
//                             }}
//                         />
//                     </Tooltip>
//                 </Space>
//             )
//         }
//     ];

//     return (
//         <Card
//             title="Silo Management"
//             extra={
//                 <Space>
//                     <Link to="/animal-assets">
//                         <Button  icon={<ArrowLeftOutlined />}>
//                             Back
//                         </Button>
//                     </Link>
//                     <Button
                        
//                         type="primary"
//                         icon={<PlusOutlined />}
//                         onClick={() => {
//                             setEditingSilo(null);
//                             form.resetFields();
//                             setModalVisible(true);
//                         }}
//                     >
//                         Add Silo
//                     </Button>
//                 </Space>
//             }
//         >
//             <Table columns={columns} dataSource={silos} loading={loading} rowKey="id" size="small"/>

//             <Modal
//                 title={editingSilo ? 'Edit Silo' : 'Add New Silo'}
//                 open={modalVisible}
//                 onCancel={() => {
//                     setModalVisible(false);
//                     setEditingSilo(null);
//                     form.resetFields();
//                 }}
//                 footer={null}
//                 width={600}
//             >
//                 <Form form={form} layout="vertical" onFinish={editingSilo ? handleUpdate : handleCreate}>
//                     <Form.Item name="silo_number" label="Silo Number" rules={[{ required: true }]}>
//                         <Input placeholder="e.g., PIG-01" />
//                     </Form.Item>

//                     <Form.Item name="name" label="Silo Name" rules={[{ required: true }]}>
//                         <Input placeholder="e.g., Pig Pen A" />
//                     </Form.Item>

//                     <Form.Item name="type_slug" label="Animal Type" rules={[{ required: true }]}>
//                         <Select placeholder="Select type">
//                             {assetTypes.map((type) => (
//                                 <Option key={type.slug} value={type.slug}>
//                                     <Tag color={type.color}>{type.name}</Tag>
//                                 </Option>
//                             ))}
//                         </Select>
//                     </Form.Item>

//                     <Form.Item name="farm_id" label="Farm">
//                         <Select placeholder="Select farm" allowClear>
//                             {farms.map((farm) => (
//                                 <Option key={farm.id} value={farm.id}>
//                                     {farm.name}
//                                 </Option>
//                             ))}
//                         </Select>
//                     </Form.Item>

//                     <Form.Item name="location" label="Location">
//                         <Input placeholder="Building/Section" />
//                     </Form.Item>

//                     <Form.Item name="capacity" label="Capacity (Units)">
//                         <InputNumber min={0} style={{ width: '100%' }} placeholder="Maximum capacity" />
//                     </Form.Item>

//                     <Form.Item name="status" label="Status" initialValue="active">
//                         <Select>
//                             <Option value="active">Active</Option>
//                             <Option value="maintenance">Maintenance</Option>
//                             <Option value="full">Full</Option>
//                             <Option value="empty">Empty</Option>
//                         </Select>
//                     </Form.Item>

//                     <Form.Item>
//                         <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
//                             <Button onClick={() => setModalVisible(false)}>Cancel</Button>
//                             <Button type="primary" htmlType="submit">
//                                 {editingSilo ? 'Update' : 'Create'}
//                             </Button>
//                         </Space>
//                     </Form.Item>
//                 </Form>
//             </Modal>
//         </Card>
//     );
// };

// export default SiloManagement;


import React, { useState, useEffect } from 'react';
import {
    Card,
    Table,
    Button,
    Modal,
    Form,
    Input,
    Select,
    InputNumber,
    Space,
    Tag,
    message,
    Tooltip,
    Row,
    Col,
    Statistic,
    Progress,
    Badge,
    Popconfirm,
    Divider,
    Typography
} from 'antd';
import {
    PlusOutlined,
    EditOutlined,
    DeleteOutlined,
    SearchOutlined,
    ReloadOutlined,
    FilterOutlined,
    ClearOutlined,
    DashboardOutlined,
    HomeOutlined
} from '@ant-design/icons';
import axios from 'axios';
import config from '../config';
import { Link } from 'react-router-dom';

const { Option } = Select;
const { Text } = Typography;

const SiloManagement = () => {
    const [silos, setSilos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [editingSilo, setEditingSilo] = useState(null);
    const [form] = Form.useForm();
    const [assetTypes, setAssetTypes] = useState([]);
    const [farms, setFarms] = useState([]);
    const [filters, setFilters] = useState({
        type_slug: '',
        farm_id: '',
        status: '',
        search: ''
    });
    const [occupancySummary, setOccupancySummary] = useState([]);
    const [loadingSummary, setLoadingSummary] = useState(false);

    const environment = window.location.hostname === 'localhost' ? 'development' : 'production';
    const apiUrl = config[environment].apiUrl;

    useEffect(() => {
        fetchSilos();
        fetchAssetTypes();
        fetchFarms();
        fetchOccupancySummary();
    }, []);

    // Fetch silos with filters
    const fetchSilos = async () => {
        setLoading(true);
        try {
            const params = new URLSearchParams();
            if (filters.type_slug) params.append('type_slug', filters.type_slug);
            if (filters.farm_id) params.append('farm_id', filters.farm_id);
            if (filters.status) params.append('status', filters.status);
            if (filters.search) params.append('search', filters.search);
            
            const response = await api.get(`/silos?${params.toString()}`);
            setSilos(response.data);
        } catch (error) {
            console.error('Error fetching silos:', error);
            message.error('Failed to load silos');
        } finally {
            setLoading(false);
        }
    };

    const fetchOccupancySummary = async () => {
        setLoadingSummary(true);
        try {
            const params = new URLSearchParams();
            if (filters.farm_id) params.append('farm_id', filters.farm_id);
            
            const response = await api.get(`/silos/occupancy-summary?${params.toString()}`);
            setOccupancySummary(response.data);
        } catch (error) {
            console.error('Error fetching occupancy summary:', error);
        } finally {
            setLoadingSummary(false);
        }
    };

    const fetchAssetTypes = async () => {
        try {
            const response = await api.get(`/asset-types-config`);
            setAssetTypes(response.data);
        } catch (error) {
            console.error('Error fetching asset types:', error);
        }
    };

    const fetchFarms = async () => {
        try {
            const response = await api.get(`/farm`);
            setFarms(response.data);
        } catch (error) {
            console.error('Error fetching farms:', error);
        }
    };

    const handleFilterChange = (key, value) => {
        setFilters({ ...filters, [key]: value });
    };

    const applyFilters = () => {
        fetchSilos();
        fetchOccupancySummary();
    };

    const resetFilters = () => {
        setFilters({
            type_slug: '',
            farm_id: '',
            status: '',
            search: ''
        });
        setTimeout(() => {
            fetchSilos();
            fetchOccupancySummary();
        }, 100);
    };

    const handleCreate = async (values) => {
        try {
            const response = await api.post(`/silos`, {
                ...values,
                user_id: 1,
                user_name: 'Admin'
            });

            if (response.data.success) {
                message.success('Silo created successfully');
                setModalVisible(false);
                form.resetFields();
                fetchSilos();
                fetchOccupancySummary();
            }
        } catch (error) {
            console.error('Error creating silo:', error);
            message.error('Failed to create silo');
        }
    };

    const handleUpdate = async (values) => {
        try {
            await api.put(`/silos/${editingSilo.id}`, values);
            message.success('Silo updated successfully');
            setEditingSilo(null);
            setModalVisible(false);
            form.resetFields();
            fetchSilos();
            fetchOccupancySummary();
        } catch (error) {
            console.error('Error updating silo:', error);
            message.error('Failed to update silo');
        }
    };

    const handleDelete = async (id) => {
        try {
            await api.delete(`/silos/${id}`);
            message.success('Silo deleted successfully');
            fetchSilos();
            fetchOccupancySummary();
        } catch (error) {
            console.error('Error deleting silo:', error);
            message.error('Failed to delete silo');
        }
    };

    // Get occupancy status color
    const getOccupancyColor = (percentage) => {
        if (percentage >= 90) return '#ff4d4f';
        if (percentage >= 70) return '#faad14';
        if (percentage >= 30) return '#1890ff';
        return '#52c41a';
    };

    const getOccupancyStatus = (percentage) => {
        if (percentage >= 90) return 'Full';
        if (percentage >= 70) return 'High';
        if (percentage >= 30) return 'Moderate';
        return 'Low';
    };

    const columns = [
        {
            title: 'Silo #',
            dataIndex: 'silo_number',
            key: 'silo_number',
            width: 110,
            fixed: 'left',
            render: (text) => <Text>{text}</Text>
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: 150,
            ellipsis: true
        },
        {
            title: 'Type',
            dataIndex: 'type_slug',
            key: 'type_slug',
            width: 100,
            render: (slug) => {
                const type = assetTypes.find((t) => t.slug === slug);
                return <Text>{type?.name || slug}</Text>;
            },
            filters: assetTypes.map(t => ({ text: t.name, value: t.slug })),
            onFilter: (value, record) => record.type_slug === value
        },
        {
            title: 'Farm',
            dataIndex: 'farm_name',
            key: 'farm_name',
            width: 120,
            ellipsis: true
        },
        {
            title: 'Location',
            dataIndex: 'location',
            key: 'location',
            width: 130,
            render: (text) => text || '-'
        },
        {
            title: 'Capacity',
            dataIndex: 'capacity',
            key: 'capacity',
            width: 100,
            align: 'right',
            render: (cap) => cap ? `${cap} units` : 'Unlimited'
        },
        {
            title: 'Current Occupancy',
            key: 'occupancy',
            width: 170,
            render: (_, record) => {
                const occupancy = record.calculated_occupancy || 0;
                const capacity = record.capacity || 0;
                const percentage = capacity > 0 ? (occupancy / capacity) * 100 : 0;
                const color = getOccupancyColor(percentage);
                
                return (
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
                            <span>{occupancy} / {capacity || '∞'}</span>
                            <span style={{ color }}>{percentage.toFixed(1)}%</span>
                        </div>
                        <Progress 
                            percent={Math.min(percentage, 100)} 
                            strokeColor={color}
                            showInfo={false}
                            size="small"
                        />
                    </div>
                );
            }
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (status) => {
                const colors = { 
                    active: 'green', 
                    maintenance: 'orange', 
                    full: 'red', 
                    empty: 'default' 
                };
                return <Tag color={colors[status] || 'default'}>{status || 'active'}</Tag>;
            },
            filters: [
                { text: 'Active', value: 'active' },
                { text: 'Maintenance', value: 'maintenance' },
                { text: 'Full', value: 'full' },
                { text: 'Empty', value: 'empty' }
            ],
            onFilter: (value, record) => record.status === value
        },
        {
            title: 'Actions',
            key: 'actions',
            width: 120,
            fixed: 'right',
            render: (_, record) => (
                <Space>
                    <Tooltip title="Edit">
                        <Button
                            icon={<EditOutlined />}
                            size="small"
                            onClick={() => {
                                setEditingSilo(record);
                                form.setFieldsValue(record);
                                setModalVisible(true);
                            }}
                        />
                    </Tooltip>
                    <Tooltip title="Delete">
                        <Popconfirm
                            title="Delete this silo?"
                            description="This action cannot be undone."
                            onConfirm={() => handleDelete(record.id)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button icon={<DeleteOutlined />} size="small" danger />
                        </Popconfirm>
                    </Tooltip>
                </Space>
            )
        }
    ];

    // Calculate total statistics
    const totalSilos = silos.length;
    const totalCapacity = silos.reduce((sum, s) => sum + (s.capacity || 0), 0);
    const totalOccupancy = silos.reduce((sum, s) => sum + (s.calculated_occupancy || 0), 0);
    const overallOccupancyRate = totalCapacity > 0 ? (totalOccupancy / totalCapacity) * 100 : 0;

    return (
        <Card
            title={
                <Space>
                    <HomeOutlined />
                    <span>Silo Management</span>
                    <Badge count={totalSilos} showZero color="blue" />
                </Space>
            }
            extra={
                <Space>
                    <Link to="/animal-assets">
                        <Button icon={<HomeOutlined />}>
                            Back
                        </Button>
                    </Link>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => {
                            setEditingSilo(null);
                            form.resetFields();
                            setModalVisible(true);
                        }}
                    >
                        Add Silo
                    </Button>
                </Space>
            }
        >
            {/* Statistics Cards */}
            <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                <Col xs={24} sm={12} md={6}>
                    <Card size="small">
                        <Statistic
                            title="Total Silos"
                            value={totalSilos}
                            prefix={<DashboardOutlined />}
                            valueStyle={{ color: '#1890ff' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card size="small">
                        <Statistic
                            title="Total Capacity"
                            value={totalCapacity}
                            suffix="units"
                            valueStyle={{ color: '#722ed1' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card size="small">
                        <Statistic
                            title="Current Occupancy"
                            value={totalOccupancy}
                            suffix="units"
                            valueStyle={{ color: '#fa8c16' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card size="small">
                        <Statistic
                            title="Occupancy Rate"
                            value={overallOccupancyRate}
                            precision={1}
                            suffix="%"
                            valueStyle={{ 
                                color: getOccupancyColor(overallOccupancyRate),
                                fontSize: 20 
                            }}
                        />
                        <Progress
                            percent={Math.min(overallOccupancyRate, 100)}
                            strokeColor={getOccupancyColor(overallOccupancyRate)}
                            size="small"
                            showInfo={false}
                            style={{ marginTop: 8 }}
                        />
                    </Card>
                </Col>
            </Row>

            {/* Occupancy Summary by Type */}
            {occupancySummary.length > 0 && (
                <div style={{ marginBottom: 16 }}>
                    <Divider orientation="left">Occupancy by Animal Type</Divider>
                    <Row gutter={[16, 16]}>
                        {occupancySummary.map((item) => {
                            const rate = item.occupancy_rate || 0;
                            const type = assetTypes.find(t => t.slug === item.type_slug);
                            return (
                                <Col xs={24} sm={12} md={8} lg={6} key={item.type_slug}>
                                    <Card size="small">
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Text>{type?.name || item.type_slug}</Text>
                                            <Badge count={`${rate.toFixed(1)}%`} style={{ backgroundColor: getOccupancyColor(rate) }} />
                                        </div>
                                        <div style={{ marginTop: 8 }}>
                                            <Progress
                                                percent={Math.min(rate, 100)}
                                                strokeColor={getOccupancyColor(rate)}
                                                size="small"
                                                format={() => `${item.total_occupancy}/${item.total_capacity}`}
                                            />
                                        </div>
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                </div>
            )}

            {/* Filter Bar */}
            <div style={{ marginBottom: 16, display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'center' }}>
                <Input
                    placeholder="Search by silo number or name..."
                    prefix={<SearchOutlined />}
                    value={filters.search}
                    onChange={(e) => handleFilterChange('search', e.target.value)}
                    style={{ width: 250 }}
                    allowClear
                />
                <Select
                    placeholder="Filter by Type"
                    value={filters.type_slug || undefined}
                    onChange={(value) => handleFilterChange('type_slug', value)}
                    style={{ width: 150 }}
                    allowClear
                >
                    {assetTypes.map((type) => (
                        <Option key={type.slug} value={type.slug}>
                            <Tag color={type.color}>{type.name}</Tag>
                        </Option>
                    ))}
                </Select>
                <Select
                    placeholder="Filter by Farm"
                    value={filters.farm_id || undefined}
                    onChange={(value) => handleFilterChange('farm_id', value)}
                    style={{ width: 150 }}
                    allowClear
                >
                    {farms.map((farm) => (
                        <Option key={farm.id} value={farm.id}>
                            {farm.name}
                        </Option>
                    ))}
                </Select>
                <Select
                    placeholder="Filter by Status"
                    value={filters.status || undefined}
                    onChange={(value) => handleFilterChange('status', value)}
                    style={{ width: 130 }}
                    allowClear
                >
                    <Option value="active">Active</Option>
                    <Option value="maintenance">Maintenance</Option>
                    <Option value="full">Full</Option>
                    <Option value="empty">Empty</Option>
                </Select>
                <Space>
                    <Button type="primary" icon={<FilterOutlined />} onClick={applyFilters}>
                        Filter
                    </Button>
                    <Button icon={<ClearOutlined />} onClick={resetFilters}>
                        Reset
                    </Button>
                    <Button icon={<ReloadOutlined />} onClick={() => {
                        fetchSilos();
                        fetchOccupancySummary();
                    }}>
                        Refresh
                    </Button>
                </Space>
            </div>

            {/* Silos Table */}
            <Table
                columns={columns}
                dataSource={silos}
                loading={loading}
                rowKey="id"
                size="small"
                scroll={{ x: 1200 }}
                pagination={{
                    pageSize: 10,
                    showSizeChanger: true,
                    showTotal: (total) => `Total ${total} silos`
                }}
            />

            {/* Create/Edit Modal */}
            <Modal
                title={editingSilo ? 'Edit Silo' : 'Add New Silo'}
                open={modalVisible}
                onCancel={() => {
                    setModalVisible(false);
                    setEditingSilo(null);
                    form.resetFields();
                }}
                footer={null}
                width={600}
            >
                <Form form={form} layout="vertical" onFinish={editingSilo ? handleUpdate : handleCreate}>
                    <Form.Item name="silo_number" label="Silo Number" rules={[{ required: true }]}>
                        <Input placeholder="e.g., PIG-01" />
                    </Form.Item>

                    <Form.Item name="name" label="Silo Name" rules={[{ required: true }]}>
                        <Input placeholder="e.g., Pig Pen A" />
                    </Form.Item>

                    <Form.Item name="type_slug" label="Animal Type" rules={[{ required: true }]}>
                        <Select placeholder="Select type">
                            {assetTypes.map((type) => (
                                <Option key={type.slug} value={type.slug}>
                                    <Tag color={type.color}>{type.name}</Tag>
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item name="farm_id" label="Farm">
                        <Select placeholder="Select farm" allowClear>
                            {farms.map((farm) => (
                                <Option key={farm.id} value={farm.id}>
                                    {farm.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item name="location" label="Location">
                        <Input placeholder="Building/Section" />
                    </Form.Item>

                    <Form.Item name="capacity" label="Capacity (Units)">
                        <InputNumber min={0} style={{ width: '100%' }} placeholder="Maximum capacity" />
                    </Form.Item>

                    <Form.Item name="status" label="Status" initialValue="active">
                        <Select>
                            <Option value="active">Active</Option>
                            <Option value="maintenance">Maintenance</Option>
                            <Option value="full">Full</Option>
                            <Option value="empty">Empty</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item>
                        <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                            <Button onClick={() => setModalVisible(false)}>Cancel</Button>
                            <Button type="primary" htmlType="submit">
                                {editingSilo ? 'Update' : 'Create'}
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Modal>
        </Card>
    );
};

export default SiloManagement;